import { IconNames } from '@blueprintjs/icons';
import { ActionButtonText } from '@strata/react-buttons';
import { useFormikContext } from 'formik';
import { useState } from 'react';

import { deletePreBid } from 'api/auctionsAPI';
import { deleteFirstRefusalClaim } from 'api/clientAPI';
import { DeleteRuleDialog } from 'components/admin/automations/dialogs/DeleteRuleDialog';
import {
    AutomationRule,
    AutomationRuleActions,
    AutomationRuleFormContext,
} from 'services/AutomationRuleHelpers';
import { handleError } from 'services/Error';
import { useAppSelector } from 'store';

interface TemplateHeaderActionsProps {
    rule?: Partial<AutomationRule>;
    userCanEdit: boolean;
    isExistingRule: boolean;
    onDeleteSuccess: (id: string) => Promise<void> | void;
    duplicateRule: (values: AutomationRuleFormContext) => void;
}

export const TemplateHeaderActions = ({
    rule = undefined,
    isExistingRule,
    userCanEdit,
    onDeleteSuccess,
    duplicateRule,
}: TemplateHeaderActionsProps) => {
    const formik = useFormikContext<AutomationRuleFormContext>();
    const selectedNpi = useAppSelector((state) => state.auth.selectedNpi);
    const [showDeleteRuleDialog, setShowDeleteRuleDialog] = useState(false);
    return (
        <>
            <DeleteRuleDialog
                isOpen={showDeleteRuleDialog}
                onSecondaryButtonClick={() => setShowDeleteRuleDialog(false)}
                onPrimaryButtonClick={() => {
                    (async () => {
                        try {
                            if (rule) {
                                setShowDeleteRuleDialog(false);
                                if (rule.action?.type === AutomationRuleActions.SET_MAX_BID) {
                                    await deletePreBid({ npi: selectedNpi!, id: rule.id! });
                                } else if (
                                    rule.action?.type === AutomationRuleActions.SEND_REFERRAL
                                ) {
                                    await deleteFirstRefusalClaim({
                                        npi: selectedNpi!,
                                        id: rule.id!,
                                        payerId: rule.payerId!,
                                        segmentId: rule.segmentId!,
                                    });
                                }
                                await onDeleteSuccess(rule.id!);
                            }
                        } catch (err) {
                            handleError(
                                'An error occurred deleting rule. Please try again.',
                                err as Error,
                            );
                        }
                    })();
                }}
            />
            {isExistingRule && (
                <div className="flex__gap--small" style={{ alignItems: 'center' }}>
                    <ActionButtonText
                        label="Duplicate Rule"
                        disabled={!userCanEdit}
                        leftIcon={IconNames.DUPLICATE}
                        onClick={() => duplicateRule(formik.values)}
                    />
                    <ActionButtonText
                        label="Delete Rule"
                        disabled={!userCanEdit}
                        leftIcon={IconNames.TRASH}
                        onClick={() => setShowDeleteRuleDialog(true)}
                    />
                </div>
            )}
        </>
    );
};
